import React from 'react';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsOfService({
  onNavigate
}: {
  onNavigate: (page: string) => void;
}) {
  return <div className="min-h-screen bg-[#111111] text-gray-300" data-id="element-366">
      {/* Header Bar */}
      <div className="w-full bg-[#0a0a0a] border-b border-gray-800 sticky top-0 z-40" data-id="element-367">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between" data-id="element-368">
          <button onClick={() => {
          onNavigate('home');
          window.scrollTo(0, 0);
        }} className="flex items-center gap-2 text-sm text-gray-400 hover:text-accent transition-colors duration-200" data-id="element-369">
            <ArrowLeft className="w-4 h-4" data-id="element-370" />
            Back to Home
          </button>
          <span className="text-sm font-bold text-gray-500 uppercase tracking-widest" data-id="element-371">
            A1C Shockproof
          </span>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-16" data-id="element-372">
        <div className="flex items-center gap-3 mb-8" data-id="element-373">
          <FileText className="w-8 h-8 text-accent" data-id="element-374" />
          <h1 className="text-3xl md:text-4xl font-bold text-white" data-id="element-375">
            Terms of Service
          </h1>
        </div>
        <p className="text-sm text-gray-500 mb-12" data-id="element-376">
          Last updated:{' '}
          {new Date().toLocaleDateString('en-US', {
          month: 'long',
          day: 'numeric',
          year: 'numeric'
        })}
        </p>

        <div className="space-y-10 text-gray-400 leading-relaxed" data-id="element-377">
          <section className="space-y-4" data-id="element-378">
            <h2 className="text-xl font-bold text-white" data-id="element-379">
              1. Agreement to Terms
            </h2>
            <p data-id="element-380">
              By purchasing, downloading, or using the A1C Shockproof (50+)
              digital manual ("the Product"), you agree to be bound by these
              Terms of Service ("Terms"). If you do not agree to these Terms, do
              not purchase or use the Product.
            </p>
            <p data-id="element-381">
              These Terms constitute a legally binding agreement between you
              ("Customer," "you," or "your") and A1C Shockproof ("Company,"
              "we," "our," or "us").
            </p>
          </section>

          <section className="space-y-4" data-id="element-382">
            <h2 className="text-xl font-bold text-white" data-id="element-383">
              2. Product Description
            </h2>
            <p data-id="element-384">
              A1C Shockproof (50+) is a digital educational manual delivered in
              PDF format. The Product provides information about metabolic
              health strategies, glucose management protocols, and lifestyle
              modifications. The Product is delivered electronically via email
              immediately after purchase.
            </p>
          </section>

          <section className="space-y-4" data-id="element-385">
            <h2 className="text-xl font-bold text-white" data-id="element-386">
              3. Purchase and Payment
            </h2>
            <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-387">
              <li data-id="element-388">
                The Product is sold at the price displayed at the time of
                purchase ($6.36 USD unless otherwise stated).
              </li>
              <li data-id="element-389">
                All payments are processed securely through Stripe using 256-bit
                SSL encryption.
              </li>
              <li data-id="element-390">
                Upon successful payment, you will receive an email with your
                download link within minutes.
              </li>
              <li data-id="element-391">
                All prices are in US Dollars (USD) unless otherwise specified.
              </li>
              <li data-id="element-392">Sales tax may be applied based on your jurisdiction.</li>
            </ul>
          </section>

          <section className="space-y-4" data-id="element-393">
            <h2 className="text-xl font-bold text-white" data-id="element-394">
              4. 60-Day Money-Back Guarantee
            </h2>
            <div className="bg-gray-900 border border-accent/20 rounded-lg p-6" data-id="element-395">
              <p data-id="element-396">
                We offer a{' '}
                <span className="text-white font-semibold" data-id="element-397">
                  60-day money-back guarantee
                </span>{' '}
                from the date of purchase. If you are not satisfied with the
                Product for any reason, you may request a full refund within 60
                days of your purchase date.
              </p>
              <p className="mt-4" data-id="element-398">To request a refund:</p>
              <ul className="list-disc list-inside space-y-2 ml-4 mt-2" data-id="element-399">
                <li data-id="element-400">
                  Send an email to{' '}
                  <span className="text-white" data-id="element-401">support@a1cshockproof.com</span>{' '}
                  with your order number
                </li>
                <li data-id="element-402">Refunds will be processed within 5-10 business days</li>
                <li data-id="element-403">Refunds are issued to the original payment method</li>
              </ul>
              <p className="mt-4 text-gray-500 text-sm" data-id="element-404">
                We reserve the right to deny refund requests that show clear
                patterns of abuse (e.g., repeated purchases and refunds).
              </p>
            </div>
          </section>

          <section className="space-y-4" data-id="element-405">
            <h2 className="text-xl font-bold text-white" data-id="element-406">
              5. Intellectual Property and License
            </h2>
            <p data-id="element-407">
              Upon purchase, you are granted a{' '}
              <span className="text-white font-semibold" data-id="element-408">
                personal, non-transferable, non-exclusive license
              </span>{' '}
              to use the Product for your own personal, non-commercial purposes.
            </p>
            <p className="font-semibold text-white mt-4" data-id="element-409">You MAY:</p>
            <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-410">
              <li data-id="element-411">Download and store the Product on your personal devices</li>
              <li data-id="element-412">Print a copy for your personal use</li>
              <li data-id="element-413">Reference the information for your own health management</li>
            </ul>
            <p className="font-semibold text-white mt-4" data-id="element-414">You MAY NOT:</p>
            <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-415">
              <li data-id="element-416">Redistribute, resell, or share the Product with others</li>
              <li data-id="element-417">
                Upload the Product to any file-sharing platform or website
              </li>
              <li data-id="element-418">
                Modify, adapt, or create derivative works based on the Product
              </li>
              <li data-id="element-419">
                Use the Product for any commercial purpose without written
                permission
              </li>
              <li data-id="element-420">Remove or alter any copyright notices or branding</li>
            </ul>
            <p className="mt-4" data-id="element-421">
              All content, text, graphics, and design elements in the Product
              are the intellectual property of A1C Shockproof and are protected
              by copyright law.
            </p>
          </section>

          <section className="space-y-4" data-id="element-422">
            <h2 className="text-xl font-bold text-white" data-id="element-423">
              6. Medical Disclaimer
            </h2>
            <div className="bg-red-950/20 border border-red-900/30 rounded-lg p-6" data-id="element-424">
              <p className="text-white font-semibold mb-4" data-id="element-425">
                IMPORTANT — PLEASE READ CAREFULLY:
              </p>
              <p data-id="element-426">
                The A1C Shockproof (50+) manual is for{' '}
                <span className="text-white font-semibold" data-id="element-427">
                  educational and informational purposes only
                </span>
                . It is NOT a substitute for professional medical advice,
                diagnosis, or treatment.
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 mt-4" data-id="element-428">
                <li data-id="element-429">
                  The information in this Product should not be used to diagnose
                  or treat any health condition.
                </li>
                <li data-id="element-430">
                  Always consult with a qualified healthcare provider before
                  making any changes to your diet, exercise routine, or
                  medication.
                </li>
                <li data-id="element-431">
                  If you have diabetes, pre-diabetes, or any metabolic
                  condition, work closely with your physician or
                  endocrinologist.
                </li>
                <li data-id="element-432">
                  Never disregard professional medical advice or delay seeking
                  it because of something you read in this Product.
                </li>
                <li data-id="element-433">
                  Individual results may vary. The outcomes described in the
                  Product are not guaranteed.
                </li>
              </ul>
              <p className="mt-4" data-id="element-434">
                By purchasing this Product, you acknowledge that you understand
                this disclaimer and agree that A1C Shockproof is not liable for
                any health outcomes resulting from the use of the information
                provided.
              </p>
            </div>
          </section>

          <section className="space-y-4" data-id="element-435">
            <h2 className="text-xl font-bold text-white" data-id="element-436">
              7. Limitation of Liability
            </h2>
            <p data-id="element-437">
              To the fullest extent permitted by applicable law, A1C Shockproof
              shall not be liable for any indirect, incidental, special,
              consequential, or punitive damages, or any loss of profits or
              revenues, whether incurred directly or indirectly, or any loss of
              data, use, goodwill, or other intangible losses resulting from:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-438">
              <li data-id="element-439">Your use or inability to use the Product</li>
              <li data-id="element-440">Any health decisions made based on the Product's content</li>
              <li data-id="element-441">
                Any unauthorized access to or use of our servers and/or personal
                information stored therein
              </li>
            </ul>
            <p className="mt-4" data-id="element-442">
              Our total liability to you for any claims arising from or related
              to the Product shall not exceed the amount you paid for the
              Product.
            </p>
          </section>

          <section className="space-y-4" data-id="element-443">
            <h2 className="text-xl font-bold text-white" data-id="element-444">
              8. User Responsibilities
            </h2>
            <p data-id="element-445">By purchasing and using the Product, you agree to:</p>
            <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-446">
              <li data-id="element-447">
                Provide accurate and complete information during the purchase
                process
              </li>
              <li data-id="element-448">Use the Product only for lawful, personal purposes</li>
              <li data-id="element-449">
                Not attempt to reverse-engineer, decompile, or extract source
                materials from the Product
              </li>
              <li data-id="element-450">
                Consult with a qualified healthcare professional before
                implementing any protocols described in the Product
              </li>
            </ul>
          </section>

          <section className="space-y-4" data-id="element-451">
            <h2 className="text-xl font-bold text-white" data-id="element-452">9. Governing Law</h2>
            <p data-id="element-453">
              These Terms shall be governed by and construed in accordance with
              the laws of the United States, without regard to conflict of law
              principles. Any disputes arising from these Terms or the use of
              the Product shall be resolved through binding arbitration in
              accordance with the rules of the American Arbitration Association.
            </p>
          </section>

          <section className="space-y-4" data-id="element-454">
            <h2 className="text-xl font-bold text-white" data-id="element-455">
              10. Changes to Terms
            </h2>
            <p data-id="element-456">
              We reserve the right to modify these Terms at any time. Updated
              Terms will be posted on this page with a revised "Last updated"
              date. Your continued use of the Product after any changes
              constitutes acceptance of the updated Terms.
            </p>
          </section>

          <section className="space-y-4" data-id="element-457">
            <h2 className="text-xl font-bold text-white" data-id="element-458">
              11. Contact Information
            </h2>
            <p data-id="element-459">
              For questions about these Terms of Service, please contact us:
            </p>
            <div className="bg-gray-900 border border-gray-800 rounded-lg p-6 mt-4" data-id="element-460">
              <p className="text-white font-semibold" data-id="element-461">A1C Shockproof</p>
              <p className="text-gray-400 mt-2" data-id="element-462">
                Email: support@a1cshockproof.com
              </p>
            </div>
          </section>
        </div>

        {/* Back Button */}
        <div className="mt-16 pt-8 border-t border-gray-800" data-id="element-463">
          <button onClick={() => {
          onNavigate('home');
          window.scrollTo(0, 0);
        }} className="flex items-center gap-2 text-accent hover:text-[#d55515] transition-colors duration-200 font-semibold" data-id="element-464">
            <ArrowLeft className="w-5 h-5" data-id="element-465" />
            Back to Home
          </button>
        </div>
      </div>
    </div>;
}